import React, { useState, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Input, Dropdown, Checkbox } from 'antd';
import SearchIcon from '@/components/icons/SearchIcon';
import cx from 'classnames';

import { useStore } from '@/models';

import SelectArrowIcon from '@/components/icons/SelectArrowIcon';
import cs from './index.module.scss';
import coinIconMap from '@/utils/coinIconMap';

interface CoinList {
  coinFullName?: string;
  coinUrl?: string;
  coin: string;
  spotAvailableBalance?: string;
  spotAvailableBalanceValue?: string;
  spotAvailableFiatAmountText?: string;
}
interface Props {
  defaultValue?: string;
  autoSelect?: boolean;
  isBorder?: boolean;
  coinList?: CoinList[];
  handleSelect: (key: string) => void;
}

const Test: React.FC<Props> = ({ handleSelect, coinList, isBorder = false }) => {
  const { t } = useTranslation();
  const { coin } = useStore();
  const [visible, setVisible] = useState(false);
  const [search, setSearch] = useState('');
  const [hideZeroBalance, setHideZeroBalance] = useState(false);
  const { coinNamesMap, coinsList, coinlogosUrls } = coin;
  const [selectedCoin, setSelectedCoin] = useState('');
  useEffect(() => {
    if (coinList && coinList?.length > 0) {
      const { coin } = coinList[0];
      setSelectedCoin(coin);
    }
  }, [coinList]);
  useEffect(() => {
    if (selectedCoin) {
      handleSelect(selectedCoin);
    }
  }, [selectedCoin]);
  const onVisibleChange = () => {
    setSearch('');
    setHideZeroBalance(false);
    setVisible(!visible);
  };
  const onSearchInputChange = (evt: any) => {
    const { target } = evt;
    setSearch(target.value);
  };
  const onSelectedItemClick = (v: any) => {
    setSearch('');
    setVisible(false);
    setSelectedCoin(v);
  };

  const filteredCoinList = useMemo(
    () =>
      coinList
        ?.filter((item: any) => item.coin.toUpperCase().includes(search.toUpperCase()))
        ?.filter((item: CoinList) => {
          if (!hideZeroBalance) return true;
          if (!item.spotAvailableBalanceValue) return true;
          return Number(item.spotAvailableBalanceValue) > 0;
        }) || [],
    [coinList, search, hideZeroBalance],
  );

  return (
    <div className={cs.container}>
      <Dropdown
        open={visible}
        onOpenChange={onVisibleChange}
        trigger={['click']}
        menu={{ items: [] }}
        dropdownRender={() => (
          <div className={cs.selectDropdown}>
            <div className={cs.countrySearchRow}>
              <div className={cs.countrySearch}>
                <Input
                  placeholder={t('common.searchcoin')}
                  onChange={onSearchInputChange}
                  value={search}
                  prefix={<SearchIcon />}
                  className="iptBorderPrefix"
                  style={{ width: '100%', height: '32px' }}
                />
              </div>
              <div className={cs.hideZeroToggleContainer}>
                <Checkbox
                  checked={hideZeroBalance}
                  onChange={e => setHideZeroBalance(e.target.checked)}
                  className={cs.hideZeroToggle}
                >
                  {t('common.hidezero1')}
                </Checkbox>
              </div>
            </div>
            {filteredCoinList
              ?.map(({ coin, spotAvailableBalance, spotAvailableFiatAmountText }: CoinList) => (
                <div
                  key={coin}
                  className={cs.selectItem}
                  onClick={() => {
                    onSelectedItemClick(coin);
                  }}
                >
                  <div className={cs.selectItemLeft}>
                    <img src={coinlogosUrls[coin] || coinIconMap[coin]} alt="" />
                    <span className={cs.coin}>{coin}</span>
                    <span>{coinNamesMap[coin]}</span>
                  </div>
                  {(spotAvailableBalance || spotAvailableFiatAmountText) && (
                    <div className={cs.selectItemRight}>
                      <span>{spotAvailableBalance || '--'}</span>
                      <span>{spotAvailableFiatAmountText || '--'}</span>
                    </div>
                  )}
                </div>
              ))}
            <div className={cs.gapBottom} />
          </div>
        )}
      >
        <div className={cx(cs.countryInfo, isBorder ? cs.countryBorderInfo : '')}>
          <div>
            <img src={coinlogosUrls[selectedCoin] || coinIconMap[selectedCoin]} alt="" />
            <span>{coinNamesMap[selectedCoin]}</span>
            <span></span>
            <span>{selectedCoin}</span>
          </div>
          {<SelectArrowIcon className="selece_icon" />}
        </div>
      </Dropdown>
    </div>
  );
};

export default observer(Test);
